import { BehaviorParameters } from 'rangeConfig/@types';
import { getInteriorsInLoftBedCabinet } from '../utils/loftbed';

const removeInteriorInLoftBedCabinet = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return;

  const currentInteriorsInCabinet = getInteriorsInLoftBedCabinet(selectedEntity);
  coreApi.entities.deleteMultiple(currentInteriorsInCabinet);
};

export default removeInteriorInLoftBedCabinet;
